import { Controller } from "@hotwired/stimulus";
import { useEmitter } from "@/emitter"

export default class extends Controller {
    static classes = [
        "on",
        "off",
    ]

    connect() {
        useEmitter(this)

        this.enable()

        this.$on('scroll:disable', () => {
            this.disable()
        })

        this.$on('scroll:enable', () => {
            this.enable()
        })
    }

    enable() {
        this.element.classList.add(...this.onClasses)
        this.element.classList.remove(...this.offClasses)
    }
    
    disable() {
        this.element.classList.add(...this.offClasses)
        this.element.classList.remove(...this.onClasses)
    }

    disconnect() {
        this.disable()

        this.$clear()
    }
}
